import React from 'react';
import { Box, Title, Text } from '@mantine/core';

export default function Module({ title, subtitle, children }) {
  const hasHeader = title || subtitle;
  
  return (
    <Box>
      {hasHeader && (
        <Box style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1, paddingBottom: 8, paddingTop: 16, textAlign: 'left' }}>
          {title && <Title order={2} style={{ fontWeight: 600, textAlign: 'left' }}>{title}</Title>}
          {subtitle && <Text c="dimmed" style={{ textAlign: 'left' }}>{subtitle}</Text>}
        </Box>
      )}
      <Box style={{ marginTop: hasHeader ? 16 : 0, textAlign: 'left', width: '100%' }}>
        {children}
      </Box>
    </Box>
  );
} 